import {createContext} from 'react';

const DisplaySettings = createContext({showBatchName:"", showModuleName:"", updateSettings:()=>{}});

export default DisplaySettings;